/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Onboarding_Fixed_Weekdays_Too_ManyInputs */

const en_us2_onboarding_fixed_weekdays_too_many = /** @type {(inputs: Onboarding_Fixed_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Pick exactly 1 day.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Pick exactly 1 day.`);
	return /** @type {LocalizedString} */ (`Pick between 1 and ${i?.count} days.`)
	
};

const pt_br2_onboarding_fixed_weekdays_too_many = /** @type {(inputs: Onboarding_Fixed_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Escolha exatamente 1 dia.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Escolha exatamente 1 dia.`);
	return /** @type {LocalizedString} */ (`Escolha entre 1 e ${i?.count} dias.`)
	
};

const es_419_onboarding_fixed_weekdays_too_many = /** @type {(inputs: Onboarding_Fixed_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Elige exactamente 1 día.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Elige exactamente 1 día.`);
	return /** @type {LocalizedString} */ (`Elige entre 1 y ${i?.count} días.`)
	
};

const pt_pt2_onboarding_fixed_weekdays_too_many = /** @type {(inputs: Onboarding_Fixed_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Escolhe exatamente 1 dia.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Escolhe exatamente 1 dia.`);
	return /** @type {LocalizedString} */ (`Escolhe entre 1 e ${i?.count} dias.`)
	
};

const fr_fr2_onboarding_fixed_weekdays_too_many = /** @type {(inputs: Onboarding_Fixed_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Choisis exactement 1 jour.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Choisis exactement 1 jour.`);
	return /** @type {LocalizedString} */ (`Choisis entre 1 et ${i?.count} jours.`)
	
};

const de_de2_onboarding_fixed_weekdays_too_many = /** @type {(inputs: Onboarding_Fixed_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Wähle genau 1 Tag.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Wähle genau 1 Tag.`);
	return /** @type {LocalizedString} */ (`Wähle zwischen 1 und ${i?.count} Tagen.`)
	
};

const it_it2_onboarding_fixed_weekdays_too_many = /** @type {(inputs: Onboarding_Fixed_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Scegli esattamente 1 giorno.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Scegli esattamente 1 giorno.`);
	return /** @type {LocalizedString} */ (`Scegli da 1 a ${i?.count} giorni.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "Pick exactly 1 day." |
* | "-1" | "Pick exactly 1 day." |
* | * | "Pick between 1 and {count} days." |
*
* @param {Onboarding_Fixed_Weekdays_Too_ManyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_fixed_weekdays_too_many = /** @type {((inputs: Onboarding_Fixed_Weekdays_Too_ManyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Fixed_Weekdays_Too_ManyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_fixed_weekdays_too_many(inputs)
	if (locale === "es-419") return es_419_onboarding_fixed_weekdays_too_many(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_fixed_weekdays_too_many(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_fixed_weekdays_too_many(inputs)
	if (locale === "de-DE") return de_de2_onboarding_fixed_weekdays_too_many(inputs)
	if (locale === "it-IT") return it_it2_onboarding_fixed_weekdays_too_many(inputs)
	return en_us2_onboarding_fixed_weekdays_too_many(inputs)
});
export { onboarding_fixed_weekdays_too_many as "onboarding.fixed_weekdays.too_many" }